import { createAsyncThunk } from '@reduxjs/toolkit';
import { sessionApiService } from 'api/session/session.api.service';

export const fetchRecipients = createAsyncThunk('session/recipients', () =>
  sessionApiService.getRecipients(),
);
